module.exports = __webpack_public_path__ + "img/icon_data1.2c449a58.svg";